/**
 * What one line of a thread says, in this language.
 *
 * A preset carries a code and no words, so the words come from the shared bundle under
 * `driverMessages`: the office's phrases and the drivers', each side its own list. Typed
 * words are shown as typed.
 */

import type { Message } from './api';

/** The words for one line: a preset's phrase in this language, or what was typed. */
export function wordsOf(
  t: (key: string, options?: Record<string, unknown>) => string,
  message: Pick<Message, 'code' | 'body' | 'direction'>,
): string {
  if (message.code !== null && message.code !== undefined) {
    const side = message.direction === 'ToDriver' ? 'office' : 'driver';

    return t(`driverMessages.${side}.${message.code}`, { defaultValue: message.code });
  }

  return message.body ?? '';
}

